/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UserInvitationDto model module.
 * @module model/UserInvitationDto
 * @version v0
 */
class UserInvitationDto {
    /**
     * Constructs a new <code>UserInvitationDto</code>.
     * @alias module:model/UserInvitationDto
     */
    constructor() { 
        
        UserInvitationDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserInvitationDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserInvitationDto} obj Optional instance to populate.
     * @return {module:model/UserInvitationDto} The populated <code>UserInvitationDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserInvitationDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('inviterId')) {
                obj['inviterId'] = ApiClient.convertToType(data['inviterId'], 'Number');
            }
            if (data.hasOwnProperty('inviterUsername')) {
                obj['inviterUsername'] = ApiClient.convertToType(data['inviterUsername'], 'String');
            }
            if (data.hasOwnProperty('inviterName')) {
                obj['inviterName'] = ApiClient.convertToType(data['inviterName'], 'String');
            }
            if (data.hasOwnProperty('invitedEmail')) {
                obj['invitedEmail'] = ApiClient.convertToType(data['invitedEmail'], 'String');
            }
            if (data.hasOwnProperty('invitedId')) {
                obj['invitedId'] = ApiClient.convertToType(data['invitedId'], 'Number');
            }
            if (data.hasOwnProperty('invitedUsername')) {
                obj['invitedUsername'] = ApiClient.convertToType(data['invitedUsername'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('invitedAt')) {
                obj['invitedAt'] = ApiClient.convertToType(data['invitedAt'], 'Date');
            }
            if (data.hasOwnProperty('acceptedAt')) {
                obj['acceptedAt'] = ApiClient.convertToType(data['acceptedAt'], 'Date');
            }
            if (data.hasOwnProperty('rejectedAt')) {
                obj['rejectedAt'] = ApiClient.convertToType(data['rejectedAt'], 'Date');
            }
            if (data.hasOwnProperty('tokenExpiresAt')) {
                obj['tokenExpiresAt'] = ApiClient.convertToType(data['tokenExpiresAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserInvitationDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserInvitationDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['inviterUsername'] && !(typeof data['inviterUsername'] === 'string' || data['inviterUsername'] instanceof String)) {
            throw new Error("Expected the field `inviterUsername` to be a primitive type in the JSON string but got " + data['inviterUsername']);
        }
        // ensure the json data is a string
        if (data['inviterName'] && !(typeof data['inviterName'] === 'string' || data['inviterName'] instanceof String)) {
            throw new Error("Expected the field `inviterName` to be a primitive type in the JSON string but got " + data['inviterName']);
        }
        // ensure the json data is a string
        if (data['invitedEmail'] && !(typeof data['invitedEmail'] === 'string' || data['invitedEmail'] instanceof String)) {
            throw new Error("Expected the field `invitedEmail` to be a primitive type in the JSON string but got " + data['invitedEmail']);
        }
        // ensure the json data is a string
        if (data['invitedUsername'] && !(typeof data['invitedUsername'] === 'string' || data['invitedUsername'] instanceof String)) {
            throw new Error("Expected the field `invitedUsername` to be a primitive type in the JSON string but got " + data['invitedUsername']);
        }
        // ensure the json data is a string
        if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
            throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
UserInvitationDto.prototype['id'] = undefined;

/**
 * @member {Number} inviterId
 */
UserInvitationDto.prototype['inviterId'] = undefined;

/**
 * @member {String} inviterUsername
 */
UserInvitationDto.prototype['inviterUsername'] = undefined;

/**
 * @member {String} inviterName
 */
UserInvitationDto.prototype['inviterName'] = undefined;

/**
 * @member {String} invitedEmail
 */
UserInvitationDto.prototype['invitedEmail'] = undefined;

/**
 * @member {Number} invitedId
 */
UserInvitationDto.prototype['invitedId'] = undefined;

/**
 * @member {String} invitedUsername
 */
UserInvitationDto.prototype['invitedUsername'] = undefined;

/**
 * @member {module:model/UserInvitationDto.StatusEnum} status
 */
UserInvitationDto.prototype['status'] = undefined;

/**
 * @member {Date} invitedAt
 */
UserInvitationDto.prototype['invitedAt'] = undefined;

/**
 * @member {Date} acceptedAt
 */
UserInvitationDto.prototype['acceptedAt'] = undefined;

/**
 * @member {Date} rejectedAt
 */
UserInvitationDto.prototype['rejectedAt'] = undefined;

/**
 * @member {Date} tokenExpiresAt
 */
UserInvitationDto.prototype['tokenExpiresAt'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
UserInvitationDto['StatusEnum'] = {

    /**
     * value: "PENDING"
     * @const
     */
    "PENDING": "PENDING",

    /**
     * value: "ACCEPTED"
     * @const
     */
    "ACCEPTED": "ACCEPTED",

    /**
     * value: "REJECTED"
     * @const
     */
    "REJECTED": "REJECTED",

    /**
     * value: "EXPIRED"
     * @const
     */
    "EXPIRED": "EXPIRED"
};



export default UserInvitationDto;

